import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";

const MainLayout = ({ children, hideFooter = false }) => {
  return (
    <div className="h-[100dvh] flex flex-col overflow-hidden">
      <Header />
      <main className="flex-grow flex flex-col overflow-hidden bg-gray-100">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default MainLayout;
